import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCompanyComponent } from "./med-icon-company.component";

@NgModule({
  declarations: [
    MedIconCompanyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCompanyComponent,
  ],
})
export class MedIconCompanyModule { }
